export type EegWaveformColorEntry = {
  color_id: string;
  channel_pair: string;
  color_hex: string;
  color_name?: string | null;
  is_system_default: boolean;
  display_order?: number | null;
  montage_id?: string | null;
};

const CACHE_KEY = "nervedx:eeg-waveform-colors:v1";

const STANDARD_1020_COLORS = [
  "#00a2ff",
  "#ff8a00",
  "#2ecc40",
  "#ff3b30",
  "#b27cff",
  "#8b5a4a",
  "#ff7ad9",
  "#a0a0a0",
  "#d8d400",
  "#00d9e8",
];

const STANDARD_CHANNELS = [
  "Fp1-F3",
  "F3-C3",
  "C3-P3",
  "P3-O1",
  "Fp2-F4",
  "F4-C4",
  "C4-P4",
  "P4-O2",
  "Fp1-F7",
  "F7-T3",
  "T3-T5",
  "T5-O1",
  "Fp2-F8",
  "F8-T4",
  "T4-T6",
  "T6-O2",
  "Fz-Cz",
  "Cz-Pz",
];

export const EEG_STANDARD_WAVEFORM_COLOR_DEFAULTS: EegWaveformColorEntry[] =
  STANDARD_CHANNELS.map((channelPair, index) => ({
    color_id: `standard-1020-${channelPair.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`,
    channel_pair: channelPair,
    color_hex: STANDARD_1020_COLORS[index % STANDARD_1020_COLORS.length],
    color_name: null,
    is_system_default: true,
    display_order: index + 1,
    montage_id: null,
  }));

export function readCachedWaveformColors(): EegWaveformColorEntry[] {
  if (typeof window === "undefined") {
    return EEG_STANDARD_WAVEFORM_COLOR_DEFAULTS;
  }
  try {
    const raw = window.localStorage.getItem(CACHE_KEY);
    if (!raw) {
      return EEG_STANDARD_WAVEFORM_COLOR_DEFAULTS;
    }
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.length > 0
      ? (parsed as EegWaveformColorEntry[])
      : EEG_STANDARD_WAVEFORM_COLOR_DEFAULTS;
  } catch {
    return EEG_STANDARD_WAVEFORM_COLOR_DEFAULTS;
  }
}

export function writeCachedWaveformColors(
  colors: EegWaveformColorEntry[],
): void {
  if (typeof window === "undefined" || colors.length === 0) {
    return;
  }
  try {
    window.localStorage.setItem(CACHE_KEY, JSON.stringify(colors));
  } catch {
    // Local storage is only a startup polish cache; rendering has defaults.
  }
}
